import {
  CreateGMNTask,
  EditGMNMeasuringPointTask,
  EditGMNTask,
  GMNClosureTask,
  GMNMonitoringPointTask,
  QualityRegimeOptions,
} from "@nens/brostar/uploadapi-client";

import { BrostarUiSchema } from "@/libs/brostar-form";

import { createGmnUiSchemaLibrary } from "./gmn-ui-schema-library";

/**
 * Unified UI Schema hook for all GMN forms.
 */
export function useGmnUiSchema(
  qualityRegime: QualityRegimeOptions | undefined
): BrostarUiSchema<
  CreateGMNTask | EditGMNTask | GMNMonitoringPointTask | GMNClosureTask | EditGMNMeasuringPointTask
> {
  const lib = createGmnUiSchemaLibrary(qualityRegime);

  return {
    "ui:order": ["metadata", "sourcedocumentData", "measuringPointsFile"],
    metadata: {
      "ui:title": "Metadata",
      projectNumber: lib.projectNumber,
      broId: lib.broIdGMN,
      qualityRegime: lib.qualityRegime,
      deliveryAccountableParty: lib.deliveryAccountableParty,
      correctionReason: lib.correctionReason,
    },
    sourcedocumentData: {
      "ui:title": "Brondocumentgegevens",
      // Start Registration fields
      name: lib.name,
      objectIdAccountableParty: lib.objectIdAccountableParty,
      deliveryContext: lib.deliveryContext,
      monitoringPurpose: lib.monitoringPurpose,
      groundwaterAspect: lib.groundwaterAspect,
      startDateMonitoring: lib.startDateMonitoring,
      measuringPoints: lib.measuringPoints,

      // Closure fields
      endDateMonitoring: lib.endDateMonitoring,

      // Edit Measuring Point fields
      eventType: lib.eventType,
      eventDate: lib.eventDate,
      measuringPointCode: lib.measuringPointCode,
      broId: lib.broIdGMW,
      tubeNumber: lib.tubeNumber,
    },
    measuringPointsFile: lib.measuringPointsFile,
  };
}
